import React, { useContext, useState } from 'react';
// import PropTypes from 'prop-types';
import Text from 'ToolboxComponents/commons/texts/text/text';
import { isMobileBreakpoint } from 'ToolboxUtils/web/is-mobile-view';
import isMobileView from 'ToolboxUtils/web/is-mobile-view';
import styled from 'styled-components';
import { ThemeContext, WebappContext } from 'ToolboxUtils/web/context/context';
import Slider from 'ToolboxComponents/commons/sliders/slider/slider/slider';
import CircuitCard from 'ToolboxComponents/commons/cards/circuit-card/circuit-card';
import CityCard from 'ToolboxComponents/commons/cards/city-card/city-card';
import CircuitWrapper from 'ToolboxComponents/webapp/pages/home-view/components/home-slider-circuits/home-slider-circuits.style';



const Circuit = props => {
  const theme = useContext(ThemeContext).state;
  const [analytics] = useContext(WebappContext).usePath('analytics');

  const [isMobile, setIsMobile] = useState(isMobileView());
  const { circuits } = props;
  const { primaryColor, tertiaryColor } = useContext(ThemeContext).state.color;

  return (
    <CircuitWrapper
      className={`home-slider-circuits circuit`}
      primaryColor={primaryColor}
      tertiaryColor={tertiaryColor}
      theme={theme}
    >
      <div className={`block-title sub`}>
        <hr></hr>
        <div className={`title`}>
          <Text path={`page.homepage.circuitsTitle`} />
        </div>
        <div className={`sub-title`}>
          <Text path={`page.homepage.circuitsSubtitle`} />
        </div>
      </div>
      {isMobile ?
      <>
      <Slider
        mobile={{
          spaceBetween: 20,
          slidesPerView: 1.1,
          slidesPadding: 12,
        }}
        desktop={{
          slidesPerView: 3,
          spaceBetween: 50,
          centerInsufficientSlides: true,
        }}
        dotsColorActive={primaryColor}
      >
        {circuits.filter(x => !!x).map((circuit, index) => (
          <CircuitCard
            onClick={() => {analytics.sendVireesInteractionsHomepageEvent()}}
            key={`circuit-card--${index}`}
            circuit={circuit}
          />
        ))}
      </Slider>
      <CityCard />
      </>
      :
        <>
         <Slider
            mobile={{
              spaceBetween: 20,
              slidesPerView: 1.1,
              slidesPadding: 12,
            }}
            desktop={{
              slidesPerView: 3,
              arrows: true,
              arrowsMiddle: true,
              spaceBetween: 50,
              centerInsufficientSlides: true,
            }}
            dotsColorActive={primaryColor}
          >
            {circuits.map((circuit, index) => (
              <CircuitCard
                onClick={() => {analytics.sendVireesInteractionsHomepageEvent()}}
                key={`circuit-card--${index}`}
                circuit={circuit}
              />
            ))}
          </Slider>
          <CityCard />
        </> 
      }
    </CircuitWrapper>
  );
};

Circuit.propTypes = {};

export default Circuit;
